export const CENTER_STEP = 'center'
export const DATE_STEP = 'date'
export const ACCEPT_STEP = 'accept'
export const SUCCESS_STEP = 'success'
